var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('b-form-select',{attrs:{"disabled":_vm.is_disabled,"options":_vm.getOptions({key: 'price_type_id', text: 'Lista de precios'}, null, null, false)},on:{"change":_vm.set_price_type},model:{value:(_vm.price_type_id),callback:function ($$v) {_vm.price_type_id=$$v},expression:"price_type_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }